export default function Skills() {      
    return (
        <section className="content" id='Skills'>
            <h2>Skills</h2>
            
            <div className='project'>
                <h3 className="mb-0">Programming Languages</h3>
                <p>Python, SQL, React, JavaScript</p>

                <h3 className='mb-0'>Libraries</h3>
                <h4 className='mb-0'>Data Science and Machine Learning</h4>
                <p>Keras, mlxtend, NLTK, Pandas, Pycaret, Python, scikit-learn, Seaborn, TensorFlow, Ultralytics, Wordcloud</p>

                <h4 className="mb-0">Web App Development</h4>
                <p>CSS, DataTable, Flask, HTML, Jinja, JS, React, SCSS, shelve, SQLAlchemy, streamlit, WTForms</p>

                <h3 className="mb-0">Tools</h3>
                <h4 className="mb-0">General</h4>
                <p>Canva, Databricks, Excel, Figma, Github, Jupyter Notebook, Knime, Oracle, PowerBI, Tableau, VSCode </p>

                <h4 className="mb-0">Data Engineering</h4>
                <p>DataBricks, Google Cloud Platform, Hadoop, Kafka, Spark, Ubuntu</p>

                <h3 className="mb-0">Certifications</h3>
                <p>- Microsoft Certified: Power BI Data Analyst Associate</p>
                <p>- AWS Academy Graduate - AWS Academy Cloud Foundations</p>
            </div>
            <div>
                <a className='up-btn' href="#Projects"><i className="up-button fas fa-arrow-up"></i></a>
            </div>
        </section>
    );
}
